import React from 'react';
import styles from './TierBadge.module.css';
import type { TierVariant } from '@app-types';

interface TierBadgeProps {
  variant: TierVariant;
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

const TierBadge: React.FC<TierBadgeProps> = ({ variant, children, className = '', dataTestId }) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'tier1':
        return styles.tier1;
      case 'tier2':
        return styles.tier2;
      case 'tier3':
        return styles.tier3;
      case 'tier4':
        return styles.tier4;
      case 'default':
        return styles.tierDefault;
      default:
        return styles.tierDefault;
    }
  };

  const tierClass = `${styles.tierBadge} ${getVariantClass()} ${className}`.trim();

  return (
    <span className={tierClass} {...(dataTestId && { 'data-test-id': dataTestId })}>
      {children}
    </span>
  );
};

export default TierBadge;
